import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';

declare const marked: {
  parse: (markdown: string) => string | Promise<string>;
};

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyData: any;
  bookingId;
  locationDetails: any = null;
  langaugeOptions: any[] = [];
  selectedLangauge: any = AppSettings.DEFAULT_LANGUAGE;
  showLanguageDropdown: boolean = false;
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private route: ActivatedRoute

  ) {}

  ngOnInit() {
    this.bookingId = this.route.snapshot.queryParams['id'];

    this.commonBindingDataService.getLanguageSettings().subscribe((result) => {
      const isLanguageSupport = result?.isLanguageSupport === true || result?.isLanguageSupport === 'true';

      const supportedLanguages = (result?.supportedLanguages ?? '').toString();
      this.langaugeOptions = supportedLanguages
        .split(',')
        .map((c) => c.trim().toLowerCase())
        .filter((c) => c)
        .map((code) => ({ label: AppSettings.LANGUAGE_LABELS[code] ?? code, value: code }));

      const defaultLanguage = (result?.defaultLanguage ?? AppSettings.DEFAULT_LANGUAGE).toString().trim().toLowerCase();
      const supportedLanguageCodes = this.langaugeOptions.map((opt) => opt.value);
      this.selectedLangauge = supportedLanguageCodes.includes(defaultLanguage) ? defaultLanguage : (supportedLanguageCodes[0] ?? defaultLanguage);

      this.showLanguageDropdown = isLanguageSupport && this.langaugeOptions.length > 0;
    });
    this.getPrivacyPolicy();
  }

  getPrivacyPolicy() {
    this.commonBindingDataService.getPrivacyPolicy(this.selectedLangauge).subscribe((result) => {
      this.privacyPolicyData = result;
      Promise.resolve(marked.parse(this.privacyPolicyData || '')).then((html) => {
        this.privacyPolicyData = html;
      });
    }, (reason) => {
      // this.errorMessage = 'The page you are looking is not exist. Please contact to your Admin.';
    });  
  }
}
